import React from "react";
import { ContextProviderComposer } from "../utils/ContextProvider";
import { StateMasterProvider } from "../contexts/StateMasterContext";
import { DistrictProvider } from "../contexts/DistrictContext";
import { CountryProvider } from "../contexts/CountryContext";
import { AuthProvider } from "../contexts/JWTContext";
import { DialogProvider } from "../contexts/DialogContext";

export const DistrictComposer = ({ children }) => {
  return (
    <ContextProviderComposer
      contextProviders={[
        <DistrictProvider key={0} />,
        <CountryProvider key={1} />,
        <StateMasterProvider key={2} />,
        <DialogProvider key={3} />,
      ]}
    >
      {children}
    </ContextProviderComposer>
  );
};
